export function formatDate(date: string | Date): string {
  const parsedDate = new Date(date);
  
  // Ensure the date is valid
  if (isNaN(parsedDate.getTime())) {
    return ''; // return empty string for invalid date
  }
  const year = parsedDate.getFullYear();
  const month = String(parsedDate.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed, so add 1
  const day = String(parsedDate.getDate()).padStart(2, '0');
  return `${day}-${month}-${year}`;
}

export const today = new Date().toISOString().split('T')[0];